import React from 'react'
import { Grid, Typography, Box } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiAlert } from '@mdi/js'
import colors from '../../../../../../assets/colors'

const LatestLeadHeader = ({ latestLead, classes }) => {
  return (
    <Box className={classes.box}>
      <Grid container alignItems="center">
        <Grid item xs={3}>
          <Grid container spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold', color: colors.error }}>
                Lead mais recente encontrado:
              </Typography>
            </Grid>
            <Grid item>
              <Typography style={{ color: colors.error }}>
                {latestLead?.id_laundry_client}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3}>
          <Grid container spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold', color: colors.error }}>
                Criado por:
              </Typography>
            </Grid>
            <Grid item>
              <Typography style={{ color: colors.error }}>
                {latestLead?.attendant}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography style={{ fontWeight: 'bold', color: colors.error }}>
                Data de criação:
              </Typography>
            </Grid>
            <Grid item>
              <Typography style={{ color: colors.error }}>
                {latestLead?.created_at}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2}>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Box className={classes.latestLead}>
                <Icon path={mdiAlert} size={1} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default LatestLeadHeader
